<template>
  <div class="timeline">
    <div class="units" v-for="bar in data" :key=bar.month>
        <div v-if="bar.incidents.length == 0" class="good click" :title="bar.month" v-on:click="$emit('select', bar)"></div>
        <div v-else class="bad click" :title="bar.month" v-on:click="$emit('select', bar)"></div>
        <div v-if="bar.incidents.length == 0" class="good"></div>
        <div v-else class="bad"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Uptime',
  props: [
    'data'
  ],
  emits: ['select']
}
</script>

<style>

.timeline {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10vh;
}

.good {
  background-color: #06d6a0;
  filter: brightness(100%);
  transition: filter 1s;
}

.bad {
  background-color: #ef476e;
  filter: brightness(100%);
  transition: filter 1s;
}

.bad:hover {
  filter: brightness(85%);
  transition: filter 0s;
}

.good:hover {
  filter: brightness(85%);
  transition: filter 0s;
}

.click {
  cursor: pointer;
}

.units > * {
  width: 5vw;
  height: 10vh;
  margin: 0.5vw;
}

.units > :last-child {
  transform: rotatex(180deg) translatey(-4px);
  mask-image: linear-gradient(transparent 0%, white 400%);
  height: 65%;
}

</style>



// WEBPACK FOOTER //
// src/components/charts/Uptime.vue